module.exports = __webpack_public_path__ + "img/76.625af12b.jpg";